import { cva } from 'class-variance-authority';

export const labelStyles = cva(['text-base font-medium text-contentMid gap-sm'], {
  variants: {
    disabled: { true: ['cursor-not-allowed', 'text-contentBase'] },
  },
  compoundVariants: [],
  defaultVariants: {},
});
